// React
import { Col, Row } from 'reactstrap';
import React, { useState, useEffect } from 'react';

// Containers Injection
import { ModalInputNotesAssociates } from '../modalForm';
import { useLoading } from '../../../containers/hooksInjection';
import { CardList } from '../../../containers/componentsInjection';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  NotesAssociates,
  CreateNotesAssociates,
  UpdateNotesAssociates,
  DeleteNotesAssociates,
  GetTypeNotes as NoteTypes,
} from '../../../../../store/actions';

const CardNotes = (props) => {
  const [selectNote, setSelectNote] = useState(null);

  const [modal_animationLeft, setmodal_animationLeft] = useState(false);
  function tog_animationLeft() {
    setSelectNote(null);
    setmodal_animationLeft(!modal_animationLeft);
  }

  const dispatch = useDispatch();
  const { loadingWithTime } = useLoading();

  const { notesAssociates, success, typeNotes } = useSelector((state) => ({
    error: state.NotesAssociates.error,
    notesAssociates: state.NotesAssociates.notesAssociates,
    success: state.NotesAssociates.success,
    typeNotes: state.TypeNotes.typeNotes,
  }));

  const handleSubmit = (idNote, note) => {
    loadingWithTime(1000);

    if (selectNote === null) {
      dispatch(CreateNotesAssociates(props.customer.id, idNote, note));
      tog_animationLeft();
    } else {
      dispatch(
        UpdateNotesAssociates(selectNote.id, {
          customer_id: props.customer.id,
          customer_note_type_id: idNote,
          note: note,
        })
      );
      tog_animationLeft();
    }
  };

  const handleDelete = (values) => {
    const { id } = values;

    dispatch(DeleteNotesAssociates(id));
  };

  const handleEdit = (values) => {
    const { id, note, note_type } = values;
    setmodal_animationLeft(true);

    setSelectNote({
      id,
      note,
      noteType: note_type,
    });
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Tipo</span>,
      sortable: false,
      width: '20%',
      selector: (cell) => {
        return (
          <ul
            className="list-inline hstack gap-2 mb-0 "
            style={{
              width: '100%',
              display: 'flex',
              alignSelf: 'center',
            }}
          >
            <li className="list-inline-item" title="Remove">
              {cell.note_type}
            </li>
          </ul>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Nota</span>,
      selector: (row) => row.note,
      sortable: true,
      width: '40%',
    },
    {
      name: <span className="font-weight-bold fs-13">Adicionado por</span>,
      selector: (row) => row.user_name,
      sortable: true,
      width: '20%',
    },
    {
      name: <span className="font-weight-bold fs-13">Criado em</span>,
      selector: (row) => row.created_at,
      format: (row) => new Date(row.created_at).toLocaleString('pt-BR'),
      sortable: true,
    },
  ];

  useEffect(() => {
    if (props.customer) {
      dispatch(NoteTypes());
      dispatch(NotesAssociates(props.customer.id));
    }
  }, [dispatch, success, props.customer]);

  return (
    <React.Fragment>
      <Row>
        <Col
          xs={12}
          style={{
            marginTop: -24,
          }}
        >
          <CardList
            isCard
            data={notesAssociates}
            title={`Notas de ${props.customer ? props.customer.name : ''}`}
            titleButton="Nova nota"
            handleButton={tog_animationLeft}
            columns={columns}
            keySearch={'note'}
            actions={[
              {
                id: 1,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => handleEdit(cellProps),
                icon: 'las la-pen',
                classNameColorIcon: 'primary',
              },
            ]}
            handleDelete={(cellProps) => handleDelete(cellProps)}
          />
        </Col>
      </Row>
      <ModalInputNotesAssociates
        toogle={tog_animationLeft}
        title={selectNote ? 'Editar Nota' : 'Adicionar Nota'}
        isOpen={modal_animationLeft}
        selectNote={selectNote ? selectNote : null}
        label="Tipo de nota"
        handleSubmit={handleSubmit}
        data={typeNotes}
      />
    </React.Fragment>
  );
};

export default CardNotes;
